import { render } from "./NewLocationFullCard.vue?vue&type=template&id=515bd8de"
import script from "./NewLocationFullCard.vue?vue&type=script&lang=js"
export * from "./NewLocationFullCard.vue?vue&type=script&lang=js"

import "./NewLocationFullCard.vue?vue&type=style&index=0&id=515bd8de&lang=css"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__